export const identifyToChatbase = async (user) => {
    const rawLang = typeof navigator !== 'undefined' ? navigator.language : 'en';
    const lang = rawLang?.toLowerCase().startsWith('fr') ? 'fr' : 'en';
  
    const messages = {
        en: ["Hi! How can I help you today?"],
        fr: ["Bonjour ! Comment puis‑je vous aider aujourd’hui ?"],

    };

    window.chatbase.setInitialMessages(messages[lang] || messages.fr);
    
    const { UserId, chatbaseJWT, FirstName } = user;
    console.log('Chatbase identify: user', user)
    if (!UserId || !chatbaseJWT) {
        console.log('Chatbase identify skipped: missing user identifier or chatbaseJWT')
        return
    }
    console.log('Chatbase identify: userId', UserId)
    console.log('Chatbase identify: chatbaseJWT', chatbaseJWT)
    console.log('Chatbase identify: FirstName', FirstName);

    window.chatbase("resetUser");
    // wait 1 second
    await new Promise(resolve => setTimeout(resolve, 1000));

    window.chatbase('identify', { user_id: `${UserId}`, token: `${chatbaseJWT}`, name: `${FirstName}` || user?.Email })
}
